<template>
  <div class="NewsCon">
    <div class="indexMain">
      <div class="title">
        <div class="t_cn">新闻动态</div>
        <div class="t_en">NEWS</div>
      </div>
      <div class="cont">
        <div class="cont_left">
          <router-link
            class="nlink"
            v-if="companyNewsList[0]"
            :to="
              splicingUrl({
                base: '/news-details?id=' + companyNewsList[0].infoId,
                index: 1 + (companyPageNo - 1) * companyPageSize,
                type: 'company',
              })
            "
          >
            <img
              class="newsImg"
              :src="
                companyNewsList[0].infoImage
                  ? $store.state.baseUrl + companyNewsList[0].infoImage
                  : ''
              "
              alt="newsImg"
            />

            <div class="c_txt">
              <div class="newsTitle textSl1">
                {{ companyNewsList[0].infoName }}
              </div>
              <div class="btn-more">
                <span>查看详情</span>
                <i class="jiantou_right"></i>
              </div>
            </div>
          </router-link>
        </div>
        <div class="cont_right">
          <div
            class="item_news"
            v-for="(item, index) in resNewsList"
            :key="index"
          >
            <router-link
              class="nlink"
              v-if="item"
              :to="
                splicingUrl({
                  base: '/news-details?id=' + item.infoId,
                  index: index - 0 + 2 + (companyPageNo - 1) * companyPageSize,
                  type: 'company',
                })
              "
            >
              <div class="newsTitle">
                <div class="textSl1">
                  {{ item.infoName }}
                </div>
              </div>
              <div class="newsTime">{{ OnConversion(item.publishTime) }}</div>
              <div class="newsDesc" v-html="item.infoContent"></div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <router-link to="/news">
      <div class="btn-viewMore">
        <span>查看详情 >></span>
      </div>
    </router-link>
  </div>
</template>

<script>
import { onConversion } from "../../utils/index.js";

export default {
  data() {
    return {
      //工控服务新闻
      companyNewsList: [],
      companyTotal: 1, // 总数
      companyPageNo: 1, // 当前页
      companyPageSize: 4, // 每页显示条数
    };
  },
  computed: {
    resNewsList() {
      let newList = JSON.parse(JSON.stringify(this.companyNewsList));
      newList.splice(0, 1);
      return newList;
    },
  },
  mounted() {
    this.getInfoManageList();
  },
  methods: {
    // url拼接
    splicingUrl({ base, index, type }) {
      return base + "&index=" + index + "&type=" + type;
    },
    // 图片路径拼接
    companyImgSrc(item) {
      return item && item.infoImage
        ? this.$store.state.baseUrl + item.infoImage
        : "";
    },
    //移除html标签
    removeHTMLTag(str) {
      str = str.replace(/(\n)/g, "");
      str = str.replace(/(\t)/g, "");
      str = str.replace(/(\r)/g, "");
      str = str.replace(/<[^>]+>|&[^>]+;/g, "");
      str = str.replace(/\s*/g, "");
      return str;
    },
    // 时间转换
    OnConversion(date) {
      return onConversion(date);
    },
    // 获取新闻列表
    async getInfoManageList() {
      let res = await this.$request.getInfoManageList({
        pageNo: this.companyPageNo,
        pageSize: this.companyPageSize,
      });
      res.rows.map((val, index) => {
        val.infoContent = this.removeHTMLTag(val.infoContent);
      });
      this.companyNewsList = res.rows;
      this.companyTotal = res.total;
      // console.log(res);
    },
  },
};
</script>

<style lang="scss" scoped>
.NewsCon {
  // overflow: hidden;
  margin: 2.08vw 0 0 0;
  height: 37.92vw;
  background: url("../../assets/images/index/newsBg.png") no-repeat;
  background-size: 100%;
  position: relative;
  padding: 1.56vw 0 0 0;
  box-sizing: border-box;
  .cont {
    position: relative;
    height: 22.92vw;
    .cont_left {
      float: left;
      width: 36.46vw;
      height: 22.92vw;
      border:3px solid #8ac91a;
      box-sizing: border-box;
      overflow: hidden;
      position: relative;
      background-color: #ffffff;
      .newsImg {
        display: block;
        width: 36.46vw;
        height: 22.92vw;
        object-fit: cover;
      }
      .c_txt {
        width: 100%;
        height: 2.6vw;
        background-color: #8ac91a;
        position: absolute;
        bottom: 0;
        left: 0;
        .newsTitle {
          padding: 0 9.38vw 0 1.56vw;
          height: 2.6vw;
          line-height: 2.6vw;
          color: #ffffff;
          font-size: 0.94vw;
        }
        .btn-more {
          text-align: center;
          cursor: pointer;
          position: absolute;
          top: 0.83vw;
          right: 1.56vw;
          span {
            font-size: 0.83vw;
            letter-spacing: 0.05vw;
            color: #ffffff;
            padding: 0 0.31vw 0 0;
          }
          .jiantou_right {
            display: inline-block;
            width: 1.98vw;
            height: 0.52vw;
            background: url("../../assets/images/index/jisntou_right_on.png")
              no-repeat;
            background-size: 100%;
          }
        }
      }
    }
    .cont_right {
      float: left;
      width: 36.46vw;
      height: 100%;
      box-sizing: border-box;
      border-top: 0.21vw solid #8ac91a;
      background-color: #f7f7f7;
      .item_news {
        padding: 1.04vw 1.04vw 1.04vw 1.04vw;
        border-bottom: 0.21vw solid #8ac91a;
        position: relative;
        cursor: pointer;
        height: 7.4vw - 2.08vw;
        .newsTitle {
          font-size: 0.94vw;
          font-weight: bold;
          color: #333333;
          padding: 0 7.29vw 0 0;
          position: relative;
          &::before {
            content: "";
            display: block;
            width: 0.42vw;
            height: 0.42vw;
            position: absolute;
            top: 50%;
            left: -0.83vw;
            margin: -0.21vw 0 0 0;
            border-radius: 50%;
            background-color: #7fb71f;
          }
        }
        .newsTime {
          font-size: 0.73vw;
          color: #999999;
          position: absolute;
          top: 1.04vw;
          right: 1.56vw;
        }
        .newsDesc {
          height: 2.92vw;
          padding-top: 0.63vw;
          font-size: 0.83vw;
          color: #666666;
          line-height: 1.46vw;
          text-align: justify;
          word-break: normal;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .btn-viewMore {
    width: 11.88vw;
    height: 2.08vw;
    line-height: 2.08vw;
    background-color: #83bb26;
    text-align: center;
    font-size: 0.83vw;
    color: #ffffff;
    cursor: pointer;
    position: absolute;
    bottom: 2.08vw;
    left: 50%;
    margin: 0 0 0 -5.94vw;
    // &:hover {
    //   background-color: #ffffff;
    //   color: #83bb26;
    // }
  }
}
@media (min-width: 1920px) {
  .NewsCon {
    // overflow: hidden;
    margin: 40px 0 0 0;
    height: 728px;
    background: url("../../assets/images/index/newsBg.png") no-repeat;
    background-size: 100%;
    position: relative;
    padding: 30px 0 0 0;
    .cont {
      position: relative;
      height: 440px;
      .cont_left {
        float: left;
        width: 700px;
        height: 440px;
        position: relative;
        .newsImg {
          display: block;
          width: 100%;
        }
        .c_txt {
          width: 100%;
          height: 50px;
          background-color: #8ac91a;
          position: absolute;
          bottom: 0;
          left: 0;
          .newsTitle {
            padding: 0 180px 0 30px;
            height: 50px;
            line-height: 50px;
            color: #ffffff;
            font-size: 18px;
          }
          .btn-more {
            text-align: center;
            cursor: pointer;
            position: absolute;
            top: 16px;
            right: 30px;
            span {
              font-size: 16px;
              letter-spacing: 1px;
              color: #ffffff;
              padding: 0 6px 0 0;
            }
            .jiantou_right {
              display: inline-block;
              width: 38px;
              height: 10px;
              background: url("../../assets/images/index/jisntou_right_on.png")
                no-repeat;
              background-size: 100%;
            }
          }
        }
      }
      .cont_right {
        float: left;
        width: 700px;
        height: 100%;
        box-sizing: border-box;
        border-top: 4px solid #8ac91a;
        background-color: #f7f7f7;
        .item_news {
          padding: 20px 30px;
          border-bottom: 4px solid #8ac91a;
          position: relative;
          cursor: pointer;
          height: 142px - 40px;
          .newsTitle {
            font-size: 18px;
            font-weight: bold;
            color: #333333;
            padding: 0 140px 0 0;
            position: relative;
            &::before {
              content: "";
              display: block;
              width: 8px;
              height: 8px;
              position: absolute;
              top: 50%;
              left: -16px;
              margin: -4px 0 0 0;
              border-radius: 50%;
              background-color: #7fb71f;
            }
          }
          .newsTime {
            font-size: 14px;
            color: #999999;
            position: absolute;
            top: 28px;
            right: 30px;
          }
          .newsDesc {
            padding-top: 12px;
            height: 56px;
            font-size: 16px;
            color: #666666;
            line-height: 28px;
            text-align: justify;
            word-break: normal;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
    .btn-viewMore {
      width: 228px;
      height: 40px;
      line-height: 40px;
      background-color: #83bb26;
      text-align: center;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
      position: absolute;
      bottom: 40px;
      left: 50%;
      margin: 0 0 0 -114px;
      // &:hover {
      //   background-color: #ffffff;
      //   color: #83bb26;
      // }
    }
  }
}
</style>